module.exports = __webpack_public_path__ + "media/house-and-land-splash.8ef31ae9.svg";